module.exports = __webpack_public_path__ + "img/newsImg12-3.b1da2d6b.png";